// removed by extract-text-webpack-plugin
module.exports = {"root":"PropertyGroup__root__3ESbm","twoColumns":"PropertyGroup__twoColumns__1OZLj","item":"PropertyGroup__item__29asK","checkIcon":"PropertyGroup__checkIcon__1e_14","hidden":"PropertyGroup__hidden__2ewKk","marketplaceFill":"PropertyGroup__marketplaceFill__26qOd","iconWrapper":"PropertyGroup__iconWrapper__3SGMZ","labelWrapper":"PropertyGroup__labelWrapper__2We45","selectedLabel":"PropertyGroup__selectedLabel__35XC8","notSelectedLabel":"PropertyGroup__notSelectedLabel__3hzbV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyGroup/PropertyGroup.css
// module id = 2065
// module chunks = 0